import { render } from "./NewsSection.vue?vue&type=template&id=2b94b3b3&ts=true"
import script from "./NewsSection.vue?vue&type=script&lang=ts"
export * from "./NewsSection.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/filmin/press-center/site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__